import React from 'react'
import {BrowserRouter} from 'react-router-dom'

export const buildRouter = app => <BrowserRouter>{app}</BrowserRouter>
